/* import __COLOCATED_TEMPLATE__ from './device-switcher.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();